<template>
  <div class="ftRow" :style="rowStyle">
    <div
      v-for="(col, index) in data"
      :key="index"
      :style="{ width: cellWidth(data, col) }"
    >
      <div class="ftCell" v-if="col.type === 'boolean'">
        <Boolean :data="col" />
      </div>
      <div v-else-if="col.type === 'actions' && $slots.actions">
        <slot name="actions"></slot>
      </div>
      <div v-else-if="col.type === 'html'">
        <div class="ftCell" v-html="col.data"></div>
      </div>
      <div v-else>
        <p class="ftCell">{{ col.data }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Boolean from "./cells/Boolean.vue";

export default {
  name: "Row",
  props: {
    border: {},
    topAligned: {},
    data: {},
  },
  components: {
    Boolean,
  },
  computed: {
    rowStyle() {
      let styles = {};
      this.border && (styles.borderBottom = "1px solid #f0f0f0");
      this.topAligned && (styles.alignItems = "flex-start");
      return styles;
    },
  },
  methods: {
    cellWidth(data, col) {
      if (col.cellType === "full") {
        return "100%";
      } else {
        let fullCells = 0;
        data.forEach((col) => {
          if (col.cellType === "full") fullCells++;
        });
        return 100 / (data.length - fullCells) + "%";
      }
    },
  },
};
</script>
